import { useSelector } from 'react-redux'
import { NavLink } from 'reactstrap'
import FirstSlide from './FirstSlide'
import SecondSlide from './SecondSlide'
import './styles.css'
import ThirdSlide from './ThirdSlide'
import { useDispatch } from 'react-redux'
import { setCreateJobSlide } from 'store/Recruitment/actions'
import { useEffect, useState } from 'react'
import { resetJobProps } from 'store/Recruitment/actions'
import { getJobs } from 'store/Recruitment/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { resetAiInterviewSetup } from 'store/Recruitment/actions'

function CreateJob() {
  const dispatch = useDispatch()
  const { createJobSlide } = useSelector((store) => store.recruitment)
  const location = useLocation()
  const [resetKey, setResetKey] = useState(0)

  useEffect(() => {
    dispatch(setCreateJobSlide(0))
    dispatch(resetJobProps())
    dispatch(resetAiInterviewSetup())
    setResetKey((prev) => prev + 1)
  }, [location.pathname, dispatch])

  useEffect(() => {
    const jobId = location.search?.split('=')?.at(1)
    if (jobId) {
      dispatch(getJobs(jobId))
    }
  }, [location.search, dispatch])

  return (
    <div key={resetKey}>
      {' '}
      <div className='settings-tabs ml-auto dFlex md-flexCol textCenter gap-10 py-1 current border'>
        <NavLink
          onClick={() => dispatch(setCreateJobSlide(0))}
          className={`${createJobSlide === 0 ? 'current' : ''}`}
        >
          Details
        </NavLink>
        <NavLink
          onClick={() => dispatch(setCreateJobSlide(1))}
          className={`${createJobSlide === 1 ? 'current' : ''}`}
        >
          Questions
        </NavLink>
        <NavLink
          onClick={() => dispatch(setCreateJobSlide(2))}
          className={`${createJobSlide === 2 ? 'current' : ''}`}
        >
          Descriptions
        </NavLink>
      </div>
      {createJobSlide === 0 && <FirstSlide />}
      {createJobSlide === 1 && <SecondSlide />}
      {createJobSlide === 2 && <ThirdSlide />}
    </div>
  )
}
export default CreateJob
